import { ReactNode } from 'react';
import {
  Control,
  FieldErrors,
  useForm,
  UseFormClearErrors,
  UseFormTrigger,
} from 'react-hook-form';

import { useYupValidation } from 'apps/shared/scripts/hooks';

import { DEFAULT_VALUES } from './constants';
import { FormValues } from './types';
import { schema } from './validation';

export interface ChildrenProps {
  clearErrors: UseFormClearErrors<FormValues>;
  control: Control<FormValues>;
  errors: FieldErrors<FormValues>;
  formValues: FormValues;
  trigger: UseFormTrigger<FormValues>;
}

export interface Props {
  children: (props: ChildrenProps) => ReactNode;
  defaultValues?: FormValues;
  onSubmit: (data: FormValues) => Promise<void>;
}

const OnboardingForm = ({ children, defaultValues, onSubmit }: Props) => {
  const {
    clearErrors,
    control,
    handleSubmit,
    formState: { errors },
    trigger,
    watch,
  } = useForm<FormValues>({
    defaultValues: { ...DEFAULT_VALUES, ...defaultValues },
    resolver: useYupValidation<FormValues>(schema),
    mode: 'onChange',
  });
  const formValues = watch();

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {children({ clearErrors, control, errors, formValues, trigger })}
    </form>
  );
};

OnboardingForm.displayName = 'OnboardingForm';

export default OnboardingForm;
